import firestore from "../firebase/firestore";

export const sendWhatsApp = async (msg) => {
  firestore.collection("automatic_notifications").add({
    status: "pending",
    ...msg,
  });
};
